import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'function-suggestion',
  standalone: true,
  imports: [
    CommonModule
  ],
  templateUrl: './function-suggestion.component.html',
  styleUrl: './function-suggestion.component.css'
})
export class FunctionSuggestionComponent {

  @Output() suggestionClick = new EventEmitter<string>;

  suggestions = [
    'Evacuation Annex',
    'Deny Entry or Closing (Lockdown) Annex',
    'Shelter-in-Place/Secure-in-Place Annex',
    'Accounting for All Persons Annex',
    'Communications and Notification Annex',
    'Continuity of Operations (COOP) Annex',
    'Recovery Annex',
    'Public Health, Medical, and Mental Health Annex',
    'Security Annex',
    'Rapid Assessment Annex'
  ]

  onClick(functionName: string): void {
    this.suggestionClick.emit(functionName);
  }
}
